<template>
    <div class="staff-dashboard">
      <!-- Background Elements -->
      <div class="page-grid"></div>
      <div class="page-orb orb-1"></div>
      <div class="page-orb orb-2"></div>
  
      <!-- Top Navigation -->
      <div class="top-nav">
        <div class="nav-container">
          <div class="nav-brand">
            <div class="nav-hex"></div>
            <span>Corporate CONNECTIONZ</span>
            <span class="nav-badge" :class="{ 'nav-badge-ceo': isCEO }">
              <svg v-if="isCEO" class="badge-crown" width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                <path d="M5 19H19V21H5V19ZM5 8L8.5 11L12 5L15.5 11L19 8L18 17H6L5 8Z"/>
              </svg>
              <span>{{ badgeLabel }}</span>
            </span>
          </div>
  
          <div class="nav-actions">
            <div class="nav-user" @click="showUserMenu = !showUserMenu">
              <div class="user-avatar">{{ initials }}</div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <div v-if="showUserMenu" class="user-dropdown" @click.stop>
                <button @click="goToSettings">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="currentColor" stroke-width="1.5"/>
                    <path d="M14.625 9.75C14.5125 10.125 14.4375 10.5375 14.4375 10.9875C14.4375 11.4375 14.5125 11.85 14.625 12.225L13.3125 13.35C13.2 13.4625 13.1625 13.6125 13.2375 13.7625L14.5125 15.9375C14.5875 16.0875 14.7375 16.125 14.8875 16.0875L16.4625 15.4875C16.9125 15.825 17.4375 16.0875 17.9625 16.2375L18.225 17.925C18.225 18.075 18.3375 18.1875 18.4875 18.1875H21.0375C21.1875 18.1875 21.3 18.075 21.3 17.925L21.5625 16.2375C22.0875 16.0875 22.6125 15.825 23.0625 15.4875L24.6375 16.0875C24.7875 16.125 24.9375 16.0875 25.0125 15.9375L26.2875 13.7625C26.3625 13.6125 26.325 13.4625 26.2125 13.35L24.9 12.225C25.05 11.85 25.125 11.4375 25.125 10.9875C25.125 10.5375 25.05 10.125 24.9 9.75L26.2125 8.625C26.325 8.5125 26.3625 8.3625 26.2875 8.2125L25.0125 6.0375C24.9375 5.8875 24.7875 5.85 24.6375 5.8875L23.0625 6.4875C22.6125 6.15 22.0875 5.8875 21.5625 5.7375L21.3 4.05C21.3 3.9 21.1875 3.7875 21.0375 3.7875H18.4875C18.3375 3.7875 18.225 3.9 18.225 4.05L17.9625 5.7375C17.4375 5.8875 16.9125 6.15 16.4625 6.4875L14.8875 5.8875C14.7375 5.85 14.5875 5.8875 14.5125 6.0375L13.2375 8.2125C13.1625 8.3625 13.2 8.5125 13.3125 8.625L14.625 9.75Z" stroke="currentColor" stroke-width="1.5"/>
                  </svg>
                  <span>Profile</span>
                </button>
                <div class="dropdown-divider"></div>
                <button @click="logout">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Hero Section -->
      <section class="hero-section">
        <div class="hero-container">
          <div class="hero-content">
            <div class="hero-text">
              <h1 class="hero-title">
                Welcome back, <span class="hero-name">{{ displayName }}</span>
              </h1>
              <p class="hero-subtitle">
                {{ heroSubtitle }}
              </p>
            </div>
  
            <div class="hero-actions">
              <button class="action-btn btn-primary" @click="goToOnboarding">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 5V15M5 10H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>Onboard Customer</span>
              </button>
  
              <button class="action-btn btn-secondary" @click="goToLeads">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7Z" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M10 12C6.68629 12 4 14.6863 4 18H16C16 14.6863 13.3137 12 10 12Z" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <span>View Leads</span>
              </button>
  
              <button class="action-btn btn-secondary" @click="goToTemplates">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M4 4H16M4 8H16M4 12H16M4 16H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span>Templates</span>
              </button>
  
              <button class="action-btn btn-secondary" @click="goToPayment">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
                </svg>
                <span>Payments</span>
              </button>

              <button class="action-btn btn-secondary" @click="goToBlog">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M9 12H15M9 16H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Manage Blog</span>
              </button>
            </div>
          </div>
        </div>
      </section>
  
      <!-- Dashboard Content -->
      <div class="dashboard-container">
        <!-- KPI Row -->
        <div class="kpi-row">
          <div class="kpi-card card-gold">
            <div class="kpi-content">
              <div class="kpi-text">
                <div class="kpi-label">Active Customers</div>
                <div class="kpi-value">{{ activeCustomers }}</div>
                <div class="kpi-meta">Live from Firestore</div>
              </div>
              <div class="kpi-icon icon-gold">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
  
          <div class="kpi-card card-graphite">
            <div class="kpi-content">
              <div class="kpi-text">
                <div class="kpi-label">Open Leads</div>
                <div class="kpi-value">{{ openLeads }}</div>
                <div class="kpi-meta">Live from Firestore</div>
              </div>
              <div class="kpi-icon icon-graphite">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                  <path d="M16 21V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V21M4 7H20M6 21H18C19.1046 21 20 20.1046 20 19V9C20 7.89543 19.1046 7 18 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
  
          <div class="pipeline-card">
            <div class="card-header">
              <div class="card-title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Pipeline Health (7 days)</span>
              </div>
              <div class="card-meta">new → contacted → qualified</div>
            </div>
            <div class="pipeline-charts">
              <div class="chart-section">
                <div class="chart-label">Inbound</div>
                <div class="chart-placeholder chart-gold">
                  <div v-for="(val, i) in sparkInbound" :key="`inbound-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
                </div>
                <div class="chart-total">{{ sparkInbound.reduce((a, b) => a + b, 0) }} total</div>
              </div>
              <div class="chart-section">
                <div class="chart-label">Progressing</div>
                <div class="chart-placeholder chart-graphite">
                  <div v-for="(val, i) in sparkProgress" :key="`progress-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
                </div>
                <div class="chart-total">{{ sparkProgress.reduce((a, b) => a + b, 0) }} total</div>
              </div>
              <div class="chart-section">
                <div class="chart-label">Demos/Proposals</div>
                <div class="chart-placeholder chart-bronze">
                  <div v-for="(val, i) in sparkProposals" :key="`proposals-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
                </div>
                <div class="chart-total">{{ sparkProposals.reduce((a, b) => a + b, 0) }} total</div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Second Row -->
        <div class="cards-row">
          <!-- Today's Focus -->
          <div class="focus-card">
            <div class="card-header">
              <div class="card-title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Today's Focus</span>
              </div>
              <div class="focus-progress">
                <svg class="progress-ring" width="40" height="40">
                  <circle class="ring-bg" cx="20" cy="20" r="16" />
                  <circle 
                    class="ring-fill" 
                    cx="20" 
                    cy="20" 
                    r="16"
                    :style="{ strokeDashoffset: progressOffset }"
                  />
                </svg>
                <span class="progress-text">{{ Math.round(focusPercent) }}%</span>
              </div>
            </div>
  
            <div class="focus-list">
              <div 
                v-for="item in focusList" 
                :key="item.id" 
                class="focus-item"
                @click="toggleFocus(item)"
              >
                <label class="focus-checkbox">
                  <input type="checkbox" v-model="item.done" @click.stop />
                  <span class="checkbox-mark"></span>
                </label>
                <div class="focus-content">
                  <div class="focus-title" :class="{ done: item.done }">
                    {{ item.title }}
                  </div>
                  <div class="focus-subtitle">{{ item.sub }}</div>
                </div>
                <span v-if="item.badge" class="focus-badge">{{ item.badge }}</span>
              </div>
            </div>
  
            <div class="card-footer">
              <button class="footer-btn btn-gradient" @click="goToLeads">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3.33334 5.33334L8.00001 8.00001L12.6667 5.33334M3.33334 10.6667L8.00001 13.3333L12.6667 10.6667M8.00001 2.66667L3.33334 5.33334L8.00001 8.00001L12.6667 5.33334L8.00001 2.66667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Jump to Leads</span>
              </button>
              <button class="footer-btn btn-text" @click="resetFocus">Reset</button>
            </div>
          </div>
  
          <!-- Team Leaderboard -->
          <div class="leaderboard-card">
            <div class="card-header">
              <div class="card-title">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9H4.5C3.67157 9 3 9.67157 3 10.5V19.5C3 20.3284 3.67157 21 4.5 21H6M6 9V21M6 9H10M6 21H10M18 9H19.5C20.3284 9 21 9.67157 21 10.5V19.5C21 20.3284 20.3284 21 19.5 21H18M18 9V21M18 9H14M18 21H14M10 3H14V21H10V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Team Leaderboard</span>
              </div>
              <div class="card-meta">motivates healthy competition</div>
            </div>
  
            <div v-if="!leaderboardLoading" class="leaderboard-list">
              <div 
                v-for="(m, i) in leaderboard" 
                :key="m.id"
                class="leaderboard-item"
              >
                <div class="leader-avatar" :class="getRankClass(i)">
                  <span>{{ m.initials }}</span>
                </div>
                <div class="leader-info">
                  <div class="leader-name">{{ m.name }}</div>
                  <div class="leader-stats">{{ m.deals }} deals • {{ m.points }} pts</div>
                </div>
                <div class="leader-rank" :class="getRankClass(i)">
                  #{{ i + 1 }}
                </div>
              </div>
            </div>
  
            <div v-else class="loading-skeleton">
              <div v-for="i in 3" :key="i" class="skeleton-item"></div>
            </div>
  
            <div class="card-footer">
              <button class="footer-btn btn-text" @click="goToLeads">
                View pipeline →
              </button>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
      <footer class="footer-section">
        <div class="footer-content">
          © {{ new Date().getFullYear() }} Corporate Connectionz — All rights reserved.
        </div>
      </footer>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
  import { auth, db } from '../firebase'
  import router from '../router'
  import { onAuthStateChanged } from 'firebase/auth'
  import {
    collection, onSnapshot, query, where, orderBy, limit, doc, getDoc,
    getCountFromServer, collectionGroup
  } from 'firebase/firestore'
  
  const displayName = ref('Staff Member')
  const showUserMenu = ref(false)
  
  /* ----- Current user profile (drives CEO vs Staff presentation) ----- */
  // `role` in Firestore stays 'Staff' for permissions purposes - `type` is
  // a separate flag we use purely to change how the dashboard *looks* for
  // someone like a founder/CEO, without granting extra access.
  const userType = ref('Staff')
  const isCEO = computed(() => (userType.value || '').toLowerCase() === 'ceo')
  const badgeLabel = computed(() => isCEO.value ? 'CEO' : 'STAFF')
  const heroSubtitle = computed(() => isCEO.value
    ? 'A full view of the business — customers, pipeline, and team performance, all in one place.'
    : 'Close deals faster with a focused, gamified workflow.')
  const initials = computed(() => {
    const n = (displayName.value || '').trim()
    if (!n || n === 'Staff Member') return 'SM'
    return n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase()
  })
  
  /* ----- Header KPIs ----- */
  const activeCustomers = ref(0)
  const openLeads = ref(0)
  let unsubCustomers, unsubLeads, unsubLeaderboard, unsubInbound, unsubInteractions, unsubNextActions
  
  /* ===== Pipeline Health (dynamic) ===== */
  const sparkInbound = ref([0, 0, 0, 0, 0, 0, 0])
  const sparkProgress = ref([0, 0, 0, 0, 0, 0, 0])
  const sparkProposals = ref([0, 0, 0, 0, 0, 0, 0])
  
  function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x }
  function windowStart() { const t = new Date(); t.setDate(t.getDate() - 6); return startOfDay(t) }
  function dayIdx(ts) {
    const start = windowStart().getTime()
    const date = ts?.seconds ? new Date(ts.seconds * 1000) : new Date(ts)
    const day = startOfDay(date).getTime()
    const i = Math.floor((day - start) / 86400000)
    return (i >= 0 && i < 7) ? i : -1
  }
  function empty7() { return [0, 0, 0, 0, 0, 0, 0] }
  
  function subInbound() {
    const qRef = query(collection(db, 'leads'), where('createdAt', '>=', windowStart()))
    unsubInbound = onSnapshot(qRef, snap => {
      const buckets = empty7()
      snap.forEach(docu => { const i = dayIdx(docu.data().createdAt); if (i >= 0) buckets[i]++ })
      sparkInbound.value = buckets
    })
  }
  
  function subInteractions() {
    const qRef = query(collectionGroup(db, 'interactions'), where('at', '>=', windowStart()))
    unsubInteractions = onSnapshot(qRef, snap => {
      const buckets = empty7()
      snap.forEach(docu => { const i = dayIdx(docu.data().at); if (i >= 0) buckets[i]++ })
      sparkProgress.value = buckets
    })
  }
  
  function subNextActions() {
    const qRef = query(collection(db, 'leads'), where('nextAction.dueAt', '>=', windowStart()))
    unsubNextActions = onSnapshot(qRef, snap => {
      const buckets = empty7()
      snap.forEach(docu => {
        const d = docu.data()?.nextAction
        if (!d || !d.dueAt) return
        if (!['demo', 'proposal'].includes((d.type || '').toLowerCase())) return
        const i = dayIdx(d.dueAt); if (i >= 0) buckets[i]++
      })
      sparkProposals.value = buckets
    })
  }
  
  /* ===== Today's Focus ===== */
  const focusList = ref([
    { id: 1, title: 'Call 3 new leads', sub: 'Keep the pipeline warm', done: false, badge: 'Outbound' },
    { id: 2, title: 'Send 2 follow-up emails', sub: 'Move deals to qualified', done: false, badge: 'Follow-up' },
    { id: 3, title: 'Schedule 1 demo', sub: 'Target high-intent prospects', done: false, badge: 'Demo' }
  ])
  const focusPercent = ref(0)
  
  const progressOffset = computed(() => {
    const circumference = 2 * Math.PI * 16
    return circumference - (focusPercent.value / 100) * circumference
  })
  
  const recalcFocus = () => {
    const total = focusList.value.length || 1
    const done = focusList.value.filter(x => x.done).length
    focusPercent.value = (done / total) * 100
  }
  const toggleFocus = (item) => { item.done = !item.done; recalcFocus() }
  const resetFocus = () => { focusList.value.forEach(i => { i.done = false }); recalcFocus() }
  recalcFocus()
  
  /* ===== Team Leaderboard ===== */
  const leaderboard = ref([])
  const leaderboardLoading = ref(false)
  
  const getRankClass = (index) => {
    if (index === 0) return 'rank-1'
    if (index === 1) return 'rank-2'
    if (index === 2) return 'rank-3'
    return 'rank-other'
  }
  
  const initialsFrom = (first, last, email) => {
    const n = `${first || ''} ${last || ''}`.trim()
    if (n) return n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase()
    if (email) return email.replace(/@.*/, '').slice(0, 2).toUpperCase()
    return '??'
  }
  
  async function hydrateUserRow(uid, points) {
    const userSnap = await getDoc(doc(db, 'users', uid))
    const u = userSnap.exists() ? userSnap.data() : {}
    const name = (u.firstName || u.fullName || '').trim()
      ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.fullName
      : (u.email || 'Unknown User')
  
    let deals = 0
    try {
      const wonQ = query(collection(db, 'leads'), where('ownerUid', '==', uid), where('status', '==', 'won'))
      const wonCount = await getCountFromServer(wonQ)
      deals = wonCount.data().count || 0
    } catch (_) { deals = 0 }
  
    return {
      id: uid,
      name,
      initials: initialsFrom(u.firstName, u.lastName, u.email),
      points: typeof points === 'number' ? points : (points?.toNumber?.() ?? 0),
      deals
    }
  }
  
  function subscribeLeaderboard() {
    const statsQ = query(collection(db, 'user_stats'), orderBy('points', 'desc'), limit(10))
    unsubLeaderboard = onSnapshot(statsQ, async (snap) => {
      leaderboardLoading.value = true
      const rows = await Promise.all(snap.docs.map(async d => {
        const data = d.data() || {}
        return hydrateUserRow(d.id, data.points ?? 0)
      }))
      leaderboard.value = rows
      leaderboardLoading.value = false
    }, () => { leaderboardLoading.value = false })
  }
  
  /* ===== Current user profile ===== */
  let unsubAuth
  async function loadCurrentUser(uid) {
    try {
      const snap = await getDoc(doc(db, 'users', uid))
      if (!snap.exists()) return
      const u = snap.data() || {}
      userType.value = u.type || 'Staff'
      const fullName = (u.firstName || u.lastName)
        ? `${u.firstName || ''} ${u.lastName || ''}`.trim()
        : ''
      displayName.value = fullName || u.fullName || u.email || 'Staff Member'
    } catch (e) {
      console.error('Error loading user profile:', e)
    }
  }
  
  /* ===== Mount / Unmount ===== */
  onMounted(() => {
    try {
      unsubAuth = onAuthStateChanged(auth, (user) => {
        if (user) loadCurrentUser(user.uid)
      })
  
      // "customers" here means paying Corporate Connectionz customers
      // (the companies onboarded via StaffOnboardCustomerView), not the
      // employees who use their platform.
      unsubCustomers = onSnapshot(collection(db, 'customers'), snap => { activeCustomers.value = snap.size })
      const openStatuses = ['new', 'contacted', 'qualified', 'proposal']
      unsubLeads = onSnapshot(query(collection(db, 'leads'), where('status', 'in', openStatuses)), snap => { openLeads.value = snap.size })
      
      subscribeLeaderboard()
      subInbound()
      subInteractions()
      subNextActions()
    } catch (e) {
      console.error('Firebase subscription error:', e)
    }
  })
  
  onBeforeUnmount(() => {
    unsubAuth?.()
    unsubCustomers?.(); unsubLeads?.(); unsubLeaderboard?.()
    unsubInbound?.(); unsubInteractions?.(); unsubNextActions?.()
  })
  
  /* ----- Nav/Auth ----- */
  const logout = async () => { 
    showUserMenu.value = false
    await auth.signOut()
    router.push('/') 
  }
  const goToSettings = () => {
    showUserMenu.value = false
    router.push('/staff-manage-settings')
  }
  const goToOnboarding = () => router.push('/staff-onboard-customer')
  const goToPayment = () => router.push('/staff-payments')
  const goToLeads = () => router.push('/staff-leads')
  const goToTemplates = () => router.push('/staff/templates')
  const goToBlog = () => router.push('/staff/blog')
  </script>
  
  <style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Syne:wght@500;600;700;800&family=Cormorant+Garamond:wght@400;500;600&display=swap');

    .staff-dashboard {
      --bg-page: #08090a;
      --bg-alt: #0f1012;
      --bg-card: #0f1012;
      --bg-card-hover: #17181c;
      --border-subtle: rgba(255, 255, 255, 0.09);
      --border-gold: rgba(201, 168, 76, 0.35);
      --text-primary: #F5F0E8;
      --text-secondary: rgba(245, 240, 232, 0.68);
      --text-muted: rgba(245, 240, 232, 0.48);
      --gold: #C9A84C;
      --gold-light: #F0D080;
      --gold-dark: #9C7A34;
      --graphite: #6A6D74;
      --graphite-dark: #3A3D44;
      --bronze: #9C7A34;
      --bronze-dark: #6B5423;

      min-height: 100vh;
      background: linear-gradient(160deg, #101114 0%, #08090a 55%, #050506 100%);
      font-family: 'Syne', -apple-system, BlinkMacSystemFont, sans-serif;
      color: var(--text-primary);
      overflow-x: hidden;
    }

    .staff-dashboard .hero-title,
    .staff-dashboard .kpi-value,
    .staff-dashboard .leader-name {
      font-family: 'Cormorant Garamond', Georgia, serif;
      letter-spacing: -0.005em;
    }
    
    /* ==================== BACKGROUND ELEMENTS ==================== */
    .page-grid {
      position: fixed;
      inset: 0;
      background-image:
        linear-gradient(to right, rgba(255, 255, 255, 0.06) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
      background-size: 60px 60px;
      mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, black 20%, transparent 70%);
      pointer-events: none;
      z-index: 0;
    }
    
    .page-orb {
      position: fixed;
      border-radius: 50%;
      filter: blur(150px);
      opacity: 0.2;
      pointer-events: none;
      z-index: 0;
    }
    
    .orb-1 {
      width: 700px;
      height: 700px;
      background: radial-gradient(circle, rgba(240, 208, 128, 0.5), transparent);
      top: -280px;
      right: -280px;
    }
    
    .orb-2 {
      width: 600px;
      height: 600px;
      background: radial-gradient(circle, rgba(74, 77, 84, 0.4), transparent);
      bottom: -220px;
      left: -220px;
    }
    
    /* ==================== TOP NAVIGATION ==================== */
    .top-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background: rgba(8, 9, 10, 0.88);
      backdrop-filter: blur(12px);
      border-bottom: 1px solid var(--border-subtle);
    }
    
    .nav-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 32px;
    }
    
    .nav-brand {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 14.5px;
      font-weight: 700;
      color: var(--text-primary);
      letter-spacing: 0.05em;
    }
    
    .nav-hex {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      background: linear-gradient(150deg, var(--gold-light) 0%, var(--gold) 55%, var(--gold-dark) 100%);
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
      transition: transform 0.3s ease;
    }
    
    .nav-brand:hover .nav-hex {
      transform: rotate(180deg) scale(1.1);
    }
    
    .nav-badge {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      padding: 5px 14px;
      background: rgba(201, 168, 76, 0.12);
      border: 1px solid var(--border-gold);
      border-radius: 20px;
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.1em;
      color: var(--gold-light);
    }
    
    .nav-badge-ceo {
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      border-color: var(--gold);
      color: #08090A;
      box-shadow: 0 3px 12px rgba(201, 168, 76, 0.35);
    }
    
    .badge-crown {
      flex-shrink: 0;
    }
    
    .nav-actions {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    
    .nav-user {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid var(--border-subtle);
      border-radius: 10px;
      color: var(--text-primary);
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;
    }
    
    .nav-user:hover {
      background: rgba(201, 168, 76, 0.08);
      border-color: var(--border-gold);
    }
    
    .user-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      color: #08090A;
      font-size: 12px;
      font-weight: 800;
      border: 2px solid var(--gold);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
    
    .user-dropdown {
      position: absolute;
      top: calc(100% + 8px);
      right: 0;
      background: #0f1012;
      border: 1px solid var(--border-gold);
      border-radius: 12px;
      padding: 8px;
      min-width: 180px;
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.45);
      z-index: 1000;
    }
    
    .user-dropdown button {
      width: 100%;
      padding: 12px 16px;
      background: transparent;
      border: none;
      color: var(--text-secondary);
      font-size: 15px;
      font-weight: 500;
      text-align: left;
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.2s ease;
      font-family: 'Syne', sans-serif;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .user-dropdown button:hover {
      background: rgba(201, 168, 76, 0.1);
      color: var(--gold-light);
    }
    
    .dropdown-divider {
      height: 1px;
      background: var(--border-subtle);
      margin: 8px 0;
    }
    
    /* ==================== HERO SECTION ==================== */
    .hero-section {
      position: relative;
      padding: 100px 0 60px;
      overflow: hidden;
    }
    
    .hero-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 24px;
      position: relative;
      z-index: 2;
    }
    
    .hero-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 32px;
    }
    
    .hero-text {
      flex: 1;
      min-width: 300px;
    }
    
    .hero-title {
      font-size: clamp(32px, 5vw, 48px);
      font-weight: 600;
      color: var(--text-primary);
      margin-bottom: 16px;
      line-height: 1.2;
      letter-spacing: -0.01em;
    }
    
    .hero-name {
      display: inline-block;
      color: var(--gold-light);
    }
    
    .hero-subtitle {
      font-size: 17px;
      line-height: 1.7;
      color: var(--text-secondary);
    }
    
    .hero-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
    }
    
    .action-btn {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      padding: 14px 24px;
      border: none;
      border-radius: 10px;
      font-family: 'Syne', sans-serif;
      font-size: 15px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;
    }
    
    .btn-primary {
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      color: #08090A;
      box-shadow: 0 4px 20px rgba(201, 168, 76, 0.3);
    }
    
    .btn-primary:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 24px rgba(201, 168, 76, 0.4);
    }
    
    .btn-secondary {
      background: rgba(255, 255, 255, 0.05);
      color: var(--text-primary);
      border: 1px solid var(--border-subtle);
    }
    
    .btn-secondary:hover {
      background: rgba(201, 168, 76, 0.08);
      border-color: var(--border-gold);
      transform: translateY(-2px);
    }
    
    /* ==================== DASHBOARD CONTAINER ==================== */
    .dashboard-container {
      max-width: 1400px;
      margin: -40px auto 0;
      padding: 0 24px 80px;
      position: relative;
      z-index: 3;
    }
    
    /* ==================== KPI ROW ==================== */
    .kpi-row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      gap: 28px;
      margin-bottom: 36px;
    }
    
    .kpi-card {
      background: var(--bg-card);
      border: 1px solid var(--border-subtle);
      border-radius: 16px;
      padding: 28px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
    }
    
    .kpi-card:hover {
      transform: translateY(-6px);
      border-color: var(--border-gold);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    }
    
    .card-gold {
      border-left: 4px solid var(--gold);
    }
    
    .card-graphite {
      border-left: 4px solid var(--graphite);
    }
    
    .kpi-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;
    }
    
    .kpi-text {
      flex: 1;
    }
    
    .kpi-label {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: var(--text-muted);
      margin-bottom: 10px;
    }
    
    .kpi-value {
      font-size: 44px;
      font-weight: 700;
      color: var(--text-primary);
      line-height: 1;
      margin-bottom: 10px;
    }
    
    .kpi-meta {
      font-size: 13px;
      color: var(--text-secondary);
    }
    
    .kpi-icon {
      width: 68px;
      height: 68px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
    }
    
    .icon-gold {
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      color: #08090A;
      box-shadow: 0 4px 20px rgba(201, 168, 76, 0.3);
    }
    
    .icon-graphite {
      background: linear-gradient(135deg, var(--graphite), var(--graphite-dark));
      color: white;
      box-shadow: 0 4px 20px rgba(74, 77, 84, 0.3);
    }
    
    .kpi-card:hover .kpi-icon {
      transform: rotate(8deg) scale(1.15);
    }
    
    /* ==================== PIPELINE CARD ==================== */
    .pipeline-card {
      background: var(--bg-card);
      border: 1px solid var(--border-subtle);
      border-radius: 16px;
      padding: 28px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      border-left: 4px solid var(--bronze);
    }
    
    .pipeline-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    }
    
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 28px;
      flex-wrap: wrap;
      gap: 12px;
      position: relative;
      z-index: 1;
    }
    
    .card-title {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 18px;
      font-weight: 700;
      color: var(--text-primary);
    }
    
    .card-title svg {
      color: var(--gold-light);
    }
    
    .card-meta {
      font-size: 12px;
      color: var(--text-muted);
    }
    
    .pipeline-charts {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 24px;
      position: relative;
      z-index: 1;
    }
    
    .chart-section {
      text-align: center;
    }
    
    .chart-label {
      font-size: 13px;
      font-weight: 700;
      color: var(--text-secondary);
      margin-bottom: 14px;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    
    .chart-placeholder {
      height: 100px;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      gap: 6px;
      border-radius: 8px;
      padding: 12px 8px;
      background: var(--bg-alt);
      border: 1px solid var(--border-subtle);
    }
    
    .chart-bar {
      flex: 1;
      border-radius: 4px 4px 0 0;
      transition: all 0.3s ease;
      min-height: 5%;
      max-width: 20px;
    }
    
    .chart-placeholder:hover .chart-bar {
      filter: brightness(1.15);
    }
    
    .chart-gold {
      background: rgba(201, 168, 76, 0.05);
      border-color: rgba(201, 168, 76, 0.25);
    }
    
    .chart-gold .chart-bar {
      background: linear-gradient(to top, var(--gold-dark), var(--gold-light));
      box-shadow: 0 2px 8px rgba(201, 168, 76, 0.3);
    }
    
    .chart-graphite {
      background: rgba(74, 77, 84, 0.1);
      border-color: rgba(74, 77, 84, 0.3);
    }
    
    .chart-graphite .chart-bar {
      background: linear-gradient(to top, var(--graphite-dark), var(--graphite));
      box-shadow: 0 2px 8px rgba(74, 77, 84, 0.3);
    }
    
    .chart-bronze {
      background: rgba(156, 122, 52, 0.06);
      border-color: rgba(156, 122, 52, 0.3);
    }
    
    .chart-bronze .chart-bar {
      background: linear-gradient(to top, var(--bronze-dark), var(--bronze));
      box-shadow: 0 2px 8px rgba(156, 122, 52, 0.3);
    }
    
    .chart-total {
      margin-top: 10px;
      font-size: 11px;
      font-weight: 700;
      color: var(--text-muted);
    }
    
    /* ==================== CARDS ROW ==================== */
    .cards-row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
      gap: 28px;
    }
    
    /* ==================== FOCUS CARD ==================== */
    .focus-card {
      background: var(--bg-card);
      border: 1px solid var(--border-subtle);
      border-radius: 16px;
      padding: 28px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      border-left: 4px solid var(--bronze);
    }
    
    .focus-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    }
    
    .focus-progress {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .progress-ring {
      transform: rotate(-90deg);
    }
    
    .ring-bg {
      fill: none;
      stroke: var(--border-subtle);
      stroke-width: 4;
    }
    
    .ring-fill {
      fill: none;
      stroke: var(--gold-light);
      stroke-width: 4;
      stroke-linecap: round;
      stroke-dasharray: 100.53;
      transition: stroke-dashoffset 0.5s ease;
    }
    
    .progress-text {
      position: absolute;
      font-size: 13px;
      font-weight: 700;
      color: var(--text-primary);
    }
    
    .focus-list {
      margin: 28px 0;
      position: relative;
      z-index: 1;
    }
    
    .focus-item {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 18px;
      background: var(--bg-alt);
      border-radius: 12px;
      margin-bottom: 14px;
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid var(--border-subtle);
    }
    
    .focus-item:hover {
      background: var(--bg-card-hover);
      border-color: var(--border-gold);
      transform: translateX(6px);
    }
    
    .focus-checkbox {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    
    .focus-checkbox input[type="checkbox"] {
      display: none;
    }
    
    .checkbox-mark {
      width: 26px;
      height: 26px;
      border: 2px solid var(--gold);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
    }
    
    .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark {
      background: var(--gold);
    }
    
    .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark::after {
      content: '✓';
      color: #08090A;
      font-size: 18px;
      font-weight: 900;
    }
    
    .focus-content {
      flex: 1;
    }
    
    .focus-title {
      font-size: 16px;
      font-weight: 700;
      color: var(--text-primary);
      margin-bottom: 6px;
      transition: all 0.2s ease;
    }
    
    .focus-title.done {
      text-decoration: line-through;
      opacity: 0.5;
    }
    
    .focus-subtitle {
      font-size: 14px;
      color: var(--text-secondary);
    }
    
    .focus-badge {
      padding: 6px 14px;
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      border-radius: 20px;
      font-size: 11px;
      font-weight: 800;
      color: #08090A;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
    
    /* ==================== LEADERBOARD CARD ==================== */
    .leaderboard-card {
      background: var(--bg-card);
      border: 1px solid var(--border-subtle);
      border-radius: 16px;
      padding: 28px;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;
      border-left: 4px solid var(--graphite);
    }
    
    .leaderboard-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
    }
    
    .leaderboard-list {
      margin: 28px 0;
      position: relative;
      z-index: 1;
    }
    
    .leaderboard-item {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 14px;
      background: var(--bg-alt);
      border-radius: 12px;
      margin-bottom: 10px;
      transition: all 0.2s ease;
      border: 1px solid var(--border-subtle);
    }
    
    .leaderboard-item:hover {
      background: var(--bg-card-hover);
      border-color: var(--graphite);
      transform: translateX(6px);
    }
    
    .leader-avatar {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: 700;
      color: #ffffff;
      border: 3px solid;
    }
    
    .rank-1 {
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      border-color: var(--gold);
      color: #08090A;
      box-shadow: 0 4px 15px rgba(201, 168, 76, 0.35);
    }
    
    .rank-2 {
      background: linear-gradient(135deg, var(--graphite), var(--graphite-dark));
      border-color: var(--graphite);
      box-shadow: 0 4px 15px rgba(74, 77, 84, 0.35);
    }
    
    .rank-3 {
      background: linear-gradient(135deg, var(--bronze), var(--bronze-dark));
      border-color: var(--bronze);
      box-shadow: 0 4px 15px rgba(156, 122, 52, 0.35);
    }
    
    .rank-other {
      background: var(--bg-alt);
      border-color: var(--border-subtle);
      color: var(--text-secondary);
    }
    
    .leader-info {
      flex: 1;
    }
    
    .leader-name {
      font-size: 16px;
      font-weight: 700;
      color: var(--text-primary);
      margin-bottom: 6px;
    }
    
    .leader-stats {
      font-size: 13px;
      color: var(--text-muted);
    }
    
    .leader-rank {
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 700;
    }
    
    .loading-skeleton {
      padding: 28px 0;
    }
    
    .skeleton-item {
      height: 70px;
      background: linear-gradient(90deg, var(--bg-alt), var(--bg-card-hover), var(--bg-alt));
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s ease-in-out infinite;
      border-radius: 12px;
      margin-bottom: 10px;
    }
    
    @keyframes skeleton-loading {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
    
    /* ==================== CARD FOOTER ==================== */
    .card-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 14px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid var(--border-subtle);
      position: relative;
      z-index: 1;
    }
    
    .footer-btn {
      padding: 12px 20px;
      border: none;
      border-radius: 10px;
      font-family: 'Syne', sans-serif;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    
    .btn-gradient {
      background: linear-gradient(150deg, var(--gold-light), var(--gold));
      color: #08090A;
      box-shadow: 0 4px 15px rgba(201, 168, 76, 0.25);
    }
    
    .btn-gradient:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(201, 168, 76, 0.35);
    }
    
    .btn-text {
      background: transparent;
      color: var(--gold-light);
    }
    
    .btn-text:hover {
      color: var(--gold);
      text-decoration: underline;
    }
    
    /* ==================== FOOTER ==================== */
    .footer-section {
      background: rgba(8, 9, 10, 0.5);
      border-top: 1px solid var(--border-subtle);
      padding: 24px 0;
      position: relative;
    }
    
    .footer-content {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 24px;
      text-align: center;
      color: var(--text-muted);
      font-size: 14px;
    }
    
    /* ==================== RESPONSIVE ==================== */
    @media (max-width: 960px) {
      .hero-content {
        flex-direction: column;
        align-items: flex-start;
      }
    
      .hero-actions {
        width: 100%;
        flex-direction: column;
      }
    
      .action-btn {
        width: 100%;
        justify-content: center;
      }
    
      .kpi-row,
      .cards-row {
        grid-template-columns: 1fr;
      }
    
      .pipeline-charts {
        grid-template-columns: 1fr;
      }
    }
    
    @media (max-width: 600px) {
      .dashboard-container {
        margin-top: -20px;
      }
    
      .kpi-card,
      .pipeline-card,
      .focus-card,
      .leaderboard-card {
        padding: 20px;
      }
    
      .hero-title {
        font-size: 32px;
      }
    
      .kpi-value {
        font-size: 36px;
      }
    }
    </style>